import React from "react"
import RequestApprovals from "@views/features/request-approvals"
import SEO from "@components/SEO"

const RequestApprovalsPage = () => (
  <div>
    <SEO
      title="EngineID - Request and Approval Workflow"
      keywords={[
        `engineid`,
        `request and approvals`,
        `security`,
        `access to your applications`,
        `password management`,
        `provision to cloud`,
        `permission management`,
        `single sign on`,
        `identity management`,
        `access management`,
      ]}
    />
    <RequestApprovals />
  </div>
)

export default RequestApprovalsPage